/**
 * 将任意输入类型转成只包含数字的String
 *
 * @param num
 * @returns {string/undefined}
 */
const toNumStr = (num: any) => {
  let output: any;
  switch (typeof num) {
    case "number":
      output = `${num}`;
      break;
    case "string":
      const tem = parseInt(num);
      if (!isNaN(tem)) {
        output = `${tem}`;
      }
      break;
  }
  return output;
};

const priceToNum = (str: any) => {
  if (typeof str === "number") {
    return str;
  } else {
    const formatNum = str && str.replace(/[^\d.]/g, "");
    return parseFloat(formatNum);
  }
};

const toThousands = (num: any) => {
  let result = "",
    counter = 0;
  num = (num || 0).toString();
  for (let i = num.length - 1; i >= 0; i--) {
    counter++;
    result = num.charAt(i) + result;
    if (!(counter % 3) && i !== 0) {
      result = "," + result;
    }
  }
  return result;
};

/**
 * 格式化数字，每三位添加逗号
 *
 * @param num
 */
const format = (num: any) => {
  let tem: any = toNumStr(num),
    result = "";
  if (tem === undefined) {
    return num;
  }
  // 加上空字符串转换成字符，判断是整型还是小数
  const temStr: string = tem + "";
  const index: number = temStr.indexOf(".");
  let decimalNum: string = "";
  if (index > -1) {
    tem = temStr.substring(0, index);
    decimalNum = temStr.substring(index);
  }
  while (tem.length > 3) {
    result = "," + tem.slice(-3) + result;
    tem = tem.slice(0, tem.length - 3);
  }
  if (tem) {
    result = tem + result;
  }
  return index > -1 ? result + decimalNum : result;
};

/**
 * 1000+的数字以上转化成1k...等简写
 *
 * @param num
 */
const simplify = (num: any) => {
  const tem: any = toNumStr(num);
  if (tem === undefined) {
    return tem;
  }
  const len: any = tem.length;
  if (len <= 3) {
    return tem;
  } else if (len >= 7) {
    //百万的级别，带m
    return tem.slice(0, len - 6) + "." + tem[len - 6] + "m";
  } else {
    return tem.slice(0, len - 3) + "." + tem[len - 3] + "k";
  }
};

const toDecimal = (x: any) => {
  let f = parseFloat(x);
  if (isNaN(f)) {
    return;
  }
  f = Math.round(x * 100) / 100;
  return f;
};

const toDecimal2 = (x: any) => {
  let f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  f = Math.round(x * 100) / 100;
  let s = f.toString();
  let rs = s.indexOf(".");
  if (rs < 0) {
    rs = s.length;
    s += ".";
  }
  while (s.length <= rs + 2) {
    s += "0";
  }
  return s;
};

/**
 * 强制保留位小数，不足的补充
 *
 * @param num
 * @param count 保留的位数
 * @returns {string}
 */
const decimal = (num: any, count = 2) => {
  const tem = toNumStr(num);
  if (tem === undefined) {
    return num;
  }
  const toFloat = parseFloat(tem);
  const factor = Math.pow(10, count);
  let result = `${Math.round(toFloat * factor) / factor}`;
  const p = result.indexOf(".");
  if (p < 0 && count > 0) {
    result += ".";
    for (let i = 0; i < count; i++) {
      result += "0";
    }
  } else {
    while (result.length <= p + count) {
      result += "0";
    }
  }
  return result;
};

//将一串数字每隔指定位数添加指定字符串
const splitNum = (num: any, per: any, str: any) => {
  let numStr: any = toNumStr(num);
  let result = "";
  while (numStr.length > per) {
    result = str + numStr.slice(-per) + result;
    numStr = numStr.slice(0, numStr.length - per);
  }
  if (numStr) {
    result = numStr + result;
  }
  return result;
};

//将一个数字格式化为指定位数 不足的前面补0  如2=>02  20=>020
const prefixInteger = (num: any, n: any) => {
  return (Array(n).join("0") + num).slice(-n);
};

// 银行卡格式校验问题
const formatBankNo = (bankNo: any) => {
  if (bankNo === "") {
    return;
  }
  let account = bankNo.toString();
  account = account.substring(0, 19); /*帐号的总数, 包括空格在内 */
  if (account.match(".[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4}") == null) {
    /* 对照格式 */
    if (
      account.match(
        ".[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4}|" +
          ".[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4}|" +
          ".[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4}|" +
          ".[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4}"
      ) == null
    ) {
      let accountNumeric = "",
        i;
      let accountChar: any;
      for (i = 0; i < account.length; i++) {
        accountChar = account.substr(i, 1);
        if (!isNaN(accountChar) && accountChar !== " ") {
          accountNumeric = accountNumeric + accountChar;
        }
      }
      account = "";
      for (i = 0; i < accountNumeric.length; i++) {
        /* 可将以下空格改为-,效果也不错 */
        if (i === 4) {
          account = account + " ";
        }
        /* 帐号第四位数后加空格 */
        if (i === 8) {
          account = account + " ";
        }
        /* 帐号第八位数后加空格 */
        if (i === 12) {
          account = account + " ";
        }
        /* 帐号第十二位后数后加空格 */
        account = account + accountNumeric.substr(i, 1);
      }
    }
  } else {
    account =
      " " +
      account.substring(1, 5) +
      " " +
      account.substring(6, 10) +
      " " +
      account.substring(14, 18) +
      "-" +
      account.substring(18, 25);
  }
  return account !== bankNo ? account : bankNo;
};

// 日期格式校验
const formatDate = (oldTime: any, newTime: any) => {
  let result: string = newTime;
  if (newTime.length === 1 && parseInt(newTime) > 1) {
    result = "0" + newTime + "/";
  }
  if (newTime.length === 2 && parseInt(newTime) > 12) {
    result = "0" + newTime.substring(0, 1) + "/" + newTime.substring(1, 2);
  }
  if (
    newTime.length === 2 &&
    parseInt(newTime) <= 12 &&
    newTime.toString().length > oldTime.toString().length
  ) {
    result = newTime + "/";
  }
  if (newTime.length > 5) {
    result = newTime.substring(0, 5);
  }
  if (newTime.length === 3 && oldTime.length === 2) {
    result = newTime.substring(0, 2) + "/" + newTime.substring(2, 3);
  }
  return result;
};

// 去掉字符串中的所有数字
const trimSpace = (str: string, is_global: string) => {
  let result;
  result = str.replace(/(^\s+)|(\s+$)/g, "");
  if (is_global.toLowerCase() === "g") {
    result = result.replace(/\s/g, "");
  }
  return result;
};

/*
* 工具类，给定两边边界(min, max)，以及需要获取的随机数数量nums，获取随机数
* 拓展参数ignores ,类型数组，定义在范围内不允许随到的内容
* */
const getBatchRandom = (min: number, max: number, nums: number, ignores: []) => {
  const randomArr: any = [];  // 存储随机数数组
  let count = 0;  // 统计变量，从0开始

  while (count < nums) {
    // 获取最大值和最小值之间的随机数
    const number: number = Math.floor(Math.random() * (max - min + 1) + min);
    if (!randomArr.includes(number)) {
      randomArr.push(number);
      count++;
    }
  }
  return randomArr;
};

export default {
  format,
  simplify,
  decimal,
  priceToNum,
  splitNum,
  prefixInteger,
  formatBankNo,
  formatDate,
  trimSpace,
  toDecimal,
  toThousands,
  toDecimal2,
  getBatchRandom
};
